(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-menu]');

  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', drawer.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-variant-json]');
    const idInput = root.querySelector('[data-variant-id]');
    const button = root.querySelector('.product-form button[type="submit"]');
    const selects = [...root.querySelectorAll('select[name^="options"]')];

    if (!json || !idInput || selects.length === 0) return;

    let variants = [];
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    const syncVariant = () => {
      const selected = selects.map((select) => select.value);
      const variant = variants.find((item) => {
        return item.options.every((option, index) => option === selected[index]);
      });

      if (!variant) return;

      idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    };

    selects.forEach((select) => select.addEventListener('change', syncVariant));
  });
})();
